import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["allBrands", "brandsSection"];

  connect() {
    this.toggle();
  }

  toggle() {
    const disabled = this.allBrandsTarget.checked;
    this.brandsSectionTarget.classList.toggle("opacity-40", disabled);
    this.brandsSectionTarget.classList.toggle("pointer-events-none", disabled);
  }
}
